import React, {Component} from 'react';
import Wrapper from "../Wrapper";
import {Link} from "react-router-dom";
import axios from 'axios';
import {Category} from "../../classes/category";
import Paginator from "../components/Paginator";
import Deleter from "../components/Deleter";
import {connect} from "react-redux";
import {User} from "../../classes/user";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Categories extends Component<{ user: User }> {
    state = {
        categories: []
    }
    page = 1;
    last_page = 0;

    componentDidMount = async () => {
        const response = await axios.get(`categories?page=${this.page}`);

        this.setState({
            categories: response.data.data
        })

        this.last_page = response.data.meta.last_page;
    }

    handleDelete = async (id: number) => {
        this.setState({
            categories: this.state.categories.filter((p: Category) => p.id !== id)
        })
    }

    handlePageChange = async (page: number) => {
        this.page = page;
        await this.componentDidMount();
    }

    actions = (id: number) => {
        if (this.props.user.canEdit('categories')) {
            return (
                <div className="btn-group mr-2">
                    <Link to={`/categories/${id}/edit`}
                          className="btn btn-sm btn-outline-secondary">
                              <FontAwesomeIcon icon={faEdit} color="#007bff" />
                    </Link>
                    <Deleter id={id} endpoint={'categories'}
                             handleDelete={this.handleDelete}/>
                </div>
            )
        }
    }

    render() {
        let addButton = null;

        if (this.props.user.canEdit('categories')) {
            addButton = (
                <div
                    className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <Link to={'/categories/create'} className="btn btn-sm btn-success">Incluir</Link>
                    </div>
                </div>
            )
        }

        return (
            <Wrapper>
                <br/>
                <h4>Listado de Categorías</h4>
                {addButton}
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Acción</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.categories.map(
                            (Category: Category) => {
                                return (
                                    <tr key={Category.id}>
                                        <td>{Category.id}</td>
                                        <td>{Category.name}</td>
                                        <td>{this.actions(Category.id)}</td>
                                    </tr>
                                )
                            }
                        )}
                        </tbody>
                    </table>
                </div>

                <Paginator lastPage={this.last_page} handlePageChange={this.handlePageChange}/>
            </Wrapper>
        );
    }
}

// @ts-ignore
export default connect(state => ({user: state.user}))(Categories);